import { Mark, mergeAttributes } from "@tiptap/core";

export const ChordMark = Mark.create({
  name: "chord",
  // Lower than Bold's default priority (100) so ChordMark renders as the outer
  // wrapper, matching the canonical "<span class=\"chords\"><strong>…</strong></span>"
  // shape used by the 840 existing chord files in Firebase Storage.
  priority: 50,

  parseHTML() {
    return [
      {
        tag: "span.chords",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, { class: "chords" }), 0];
  },

  addKeyboardShortcuts() {
    return {
      "Mod-r": () => this.editor.commands.toggleMark(this.name),
    };
  },
});
